<template>
  <div class="payment-wrapper">
    <div class="header">
      <payment-logo :product-type="code" />
    </div>
    <mm-spinner :visible="loading" />
    <div
      class="container"
      v-show="!loading"
    >
      <Product
        v-if="!isPaidOrder"
        :product-list="productList"
        :account-info="accountInfo"
        @submitOrder="submitOrder"
        :product-type="code"
      />
      <OrderInfo
        v-show="isPaidOrder"
        :order="order"
        :account-info="accountInfo"
        @cancelOrder="fetchOrderInfo"
        :product-type="code"
        :product-info="productInfo"
      />
    </div>
  </div>
</template>

<script>
import PaymentApi from "@api/payment";
import Product from "./component/Product.vue";
import OrderInfo from "./component/OrderInfo.vue";
import PaymentLogo from "./component/PaymentLogo.vue";

export default {
    name: "Payment",
    components: {
        Product,
        OrderInfo,
        PaymentLogo
    },
    data() {
        return {
            loading: false,
            productList: [],
            order: {},
            token: '',
            productInfo: {},
            accountInfo: {
                valid_to: '',
                count_left: 0,
                token: '',
                account_id: ''
            }
        };
    },
    mounted() {
        this.init();
    },
    computed: {
      code: {
        get() {
          return this.$route.path.includes('leads') ? 'leads_personal' : 'io';
        }
      },
      isPaidOrder() {
        return this.accountInfo.is_paid_order === 1;
      }
    },
    watch: {
        code: {
          handler() {
            if (this.code === 'io') {
            document.title="OKKI IO次数购买"
          }
          if (this.code === 'leads_personal') {
            document.title="OKKI Leads AI体验版购买"
          }
        },
        immediate: true,
        deep: true
        }
    },
    methods: {
        init() {
            this.token = this.$route.query.token;
            // 通过页面token获取商品/待支付订单信息
            this.fetchOrderInfo();
        },
        fetchOrderInfo() {
            this.loading = true;

            PaymentApi.getCustomerInfo({token: this.token, code: this.code}).then(res => {
              const product = res.product;
              let products = []

              if (res.account_info.has_order === true) {
                window.location.href = '/payment/success?productType=' + this.code;
              }

              if (this.code === 'leads_personal') {
                const service = product.service || []
                products .push({
                  ...product,
                  discount: product.discount || undefined,
                  productName: product.product_name,
                  productDetail: service.map((item) => item.standard_count + item.unit_desc +  item.service_name).join('、'),
                });
              } else [
                products = product
              ]
              this.productList = products;
              this.accountInfo = res.account_info;
              this.order = res.order;
              this.productInfo = res;
          }).catch((res)=>{
            // eslint-disable-next-line no-console
            console.error('catch error', res)
            if (res.code === -1 && res.msg ) {
              window.location.href = '/payment/fail?msg=' + res.msg;
            }
          }).finally(() => {
              this.loading = false;
          });
        },
        submitOrder() {
            setTimeout(() => {
                this.fetchOrderInfo();
            }, 100);
        }
    },
};
</script>

<style lang="scss" >
@font-face {
  font-family: NumberFont;
  src: url('../../assets/font/MiSans-Medium.ttf');
}

// 定义主题色
$theme-color: #0891ff;
$hover-color: #0070D9;
body {
  color-scheme: light;
}
.payment-wrapper{
    width: 100vw;
    height: 100vh;
    background-color: #f5f5f5;
}
.header{
    padding: 20px 24px;
    height: 60px;
    width: 100%;
    background: #fff;
    border-bottom: 1px;
    border-color: #F0F0F0;
    /* 屏幕高度或宽度小于600px时不展示 */
    @media screen and (max-width: 600px) {
        display: none;
    }
}
.container {
    background: #fff;
    @media screen and (min-width: 1024px) {
        width: 800px;
        margin: auto;
    }

    @media screen and (max-width: 600px) {
        height: 100%;
    }
}
.customer-header{
    display: flex;
    align-items: center;
    padding: 24px;
    height: 90px;
    width: 100%;
    background: linear-gradient(91.29deg, #00D3D3 0%, #00A3FF 50.52%, #0064FF 100%);
    border-bottom: 1px;
    border-color: #F0F0F0;

    @media screen and (max-width: 600px) {
        padding: 24px 16px;
    }
}
.avatar{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #328bff;
}

.account-info {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    margin-left: 12px;
    color: #fff;
}

.content {
    padding: 24px;
    .tips {
        margin-top: 20px;
        // ul的样式 圆点
        padding-left: 22px;
        li {
            font-size: 14px;
            color: #666;
            line-height: 22px;
            list-style: disc;
        }
    }

    @media screen and (max-width: 600px) {
        padding: 16px;
    }
}

.agreement {
  color: #666;
  display: flex;
  align-items: flex-start;

  a {
    color: $theme-color;
  }


  .mm-checkbox{
    cursor: pointer;
    margin-right: 6px;
    outline: none;

    input:focus {
        outline: none;
    }
  }


  .mm-checkbox input[type="checkbox"]:checked + .mm-checkbox-input {
            background: $theme-color;
            border-color: $theme-color;
    }
}




.submit-btn{
    width: fit-content;
    position: relative;
    display: inline-flex;
    height: 36px;
    min-width: 90px;
    padding: 0px var(--24-px, 24px);
    justify-content: center;
    align-items: center;
    gap: var(--4-px, 4px);
    flex-shrink: 0;
    border-radius: 18px;
    background: $theme-color;
    border-color: $theme-color;
    /* sh2 */
    box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.08);
    color: #fff;
    padding: 0 24px;
    cursor: pointer;
    margin-top: 24px;
    font-size: 14px;
    span {
        font-family: NumberFont;
    }

    .discount {
        font-family: unset;
        top: -12px;
        position: absolute;
        height: 20px;
        padding: 0 4px;
        border-radius: 8px 4px 8px 0px;
        box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.08);
        color: var(--t-orange-2, #E05409);
        background: var(--t-orange-1, #FFECE1);
        font-weight: bold;
        right: 0;
        line-height: 20px;
    }

    // 屏幕高度或宽度小于600px时宽度为100%
    @media screen and (max-width: 600px) {
        width: 100%;
    }

    &:hover{
        background-color: $hover-color;
        border-color: $hover-color;
    }
}
</style>
